export const SCHEDULE_TEMPLATE_REQUEST = 'SCHEDULE_TEMPLATE_REQUEST'
export const SCHEDULE_TEMPLATE_SUCCESS = 'SCHEDULE_TEMPLATE_SUCCESS'
export const SCHEDULE_TEMPLATE_ERROR = 'SCHEDULE_TEMPLATE_ERROR'